import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { AppStoreBadge } from './StoreButtons';

const navLinks = [
  { label: 'Home', to: '/', type: 'route' },
  { label: 'Features', to: '/#features', type: 'hash' },
  { label: 'Pricing', to: '/#pricing', type: 'hash' },
  { label: 'Fly Guide', to: '/fly-guide', type: 'route' },
  { label: 'Contact', to: '/contact', type: 'route' },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#0F1419]/90 backdrop-blur-md border-b border-white/10">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src="https://customer-assets.emergentagent.com/job_fishing-companion-4/artifacts/8tms506a_symbol.svg"
              alt="FlyFinder logo"
              className="h-10 w-auto group-hover:scale-110 transition-transform duration-300"
            />
            <span className="text-2xl font-bold text-white">FlyFinder</span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) =>
              link.type === 'route' ? (
                <Link key={link.label} to={link.to} className="text-slate-300 hover:text-[#3aa0e0] font-medium transition-colors">
                  {link.label}
                </Link>
              ) : (
                <a key={link.label} href={link.to} className="text-slate-300 hover:text-[#3aa0e0] font-medium transition-colors">
                  {link.label}
                </a>
              )
            )}
            <AppStoreBadge className="h-10" />
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-colors"
            aria-label="Toggle navigation menu"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden py-4 border-t border-white/10">
            <div className="flex flex-col space-y-2">
              {navLinks.map((link) =>
                link.type === 'route' ? (
                  <Link
                    key={link.label}
                    to={link.to}
                    className="text-slate-300 hover:text-white font-medium transition-colors px-4 py-2 hover:bg-white/5 rounded-lg"
                    onClick={() => setIsOpen(false)}
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={link.label}
                    href={link.to}
                    className="text-slate-300 hover:text-white font-medium transition-colors px-4 py-2 hover:bg-white/5 rounded-lg"
                    onClick={() => setIsOpen(false)}
                  >
                    {link.label}
                  </a>
                )
              )}
              <div className="px-4 pt-1" onClick={() => setIsOpen(false)}>
                <AppStoreBadge className="h-11" />
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
